import { addItemToCollection } from "directus/src/operations";

// Add createProject function
export async function createProject({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "logo",
        "name",
        "project_id",
        "client",
        "sales_coordinator",
        "coordinator",
        "account_manager",
        "legal_entity",
        "description",
        "project_id",
      ],
    };

    const data = await addItemToCollection("projects", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
